import ZapierLogo from '@/assets/images/oAuth/zapier.png';
import { ScopeData } from '@payaca/types/authTypes';

enum Scopes {
  JOBS_READ = 'jobs:read',
  JOBS_WRITE = 'jobs:write',
  CUSTOMERS_READ = 'customers:read',
  CUSTOMERS_WRITE = 'customers:write',
  USERS_READ = 'users:read',
}

// Add scope details if oauth scopes expand
const ScopeInfo: { [key: string]: Omit<ScopeData, 'scope'> } = {
  [Scopes.JOBS_READ]: {
    description: 'View relevant job information on your account',
    icon: 'file-invoice',
  },
  [Scopes.JOBS_WRITE]: {
    description: 'Edit relevant job information on your account',
    icon: 'file-invoice',
  },
  [Scopes.CUSTOMERS_READ]: {
    description: 'View relevant customer information on your account',
    icon: 'users-01.3',
  },
  [Scopes.CUSTOMERS_WRITE]: {
    description: 'Edit relevant customer information on your account',
    icon: 'users-01.3',
  },
  [Scopes.USERS_READ]: {
    description: 'View basic profile information on your account',
    icon: 'user-circle.3',
  },
};

const OAuthImage: any = {
  zapier: ZapierLogo,
  test: ZapierLogo,
};

// oxlint-disable-next-line typescript/no-redundant-type-constituents -- FIXME: pre-existing error: 'any' overrides all other types in this union type.
const getScopeList = (scopeString: string | any): ScopeData[] => {
  // split scopes from query
  const splitScopes: string[] = scopeString ? scopeString.split(' ') : [];
  // get description and icon for scope
  const scopes: ScopeData[] = splitScopes.reduce(
    (acc: ScopeData[], scope: string) => {
      const scopeInfo = ScopeInfo[scope];
      if (scopeInfo && scopeInfo.description && scopeInfo.icon) {
        acc.push({
          scope,
          description: scopeInfo.description,
          icon: scopeInfo.icon,
        });
      }
      return acc;
    },
    []
  );
  return scopes;
};

const getAppLogo = (appName: string) => OAuthImage[appName.toLowerCase()];

export { getAppLogo, getScopeList };
